export const openCenteredWindow = (url, options = {}, isMobile = false) => {
  // For mobile devices, redirect instead of opening new window
  if (isMobile) {
    window.location.href = url;
    return null;
  }

  const defaultOptions = {
    width: Math.min(window.innerWidth * 0.9, 450),
    height: Math.min(window.innerHeight * 0.9, 675),
    resizable: true,
    scrollbars: true,
  };

  const finalOptions = { ...defaultOptions, ...options };
  const { width, height } = finalOptions;

  const left = window.screenX + (window.innerWidth - width) / 2;
  const top = window.screenY + (window.innerHeight - height) / 2;

  const features = Object.entries({
    ...finalOptions,
    left,
    top,
  })
    .map(([key, value]) => `${key}=${value}`)
    .join(',');

  return window.open(url, '_blank', features);
};
